import { Grid, Typography, Box } from '@material-ui/core';
import React from 'react';
import { FormattedMessage } from 'react-intl';

type TermsHeaderProps = {
  anyPaid: boolean;
};

const TermsHeader = function TermsHeader({
  anyPaid
}: TermsHeaderProps): React.ReactElement {
  return (
    <Grid container justify='flex-end' direction='row'>
      <Grid item xs={anyPaid ? 1 : 1}>
        <Typography color='primary'>
          <Box fontWeight='bold' />
        </Typography>
      </Grid>
      <Grid item xs={anyPaid ? 1 : 3}>
        <Typography color='primary'>
          <Box fontWeight='bold'>
            <FormattedMessage
              id='PaymentTerms.DueUpon'
              defaultMessage='Due Upon'
            />
          </Box>
        </Typography>
      </Grid>
      <Grid item xs={anyPaid ? 1 : 2}>
        <Typography color='primary'>
          <Box fontWeight='bold'>
            <FormattedMessage
              id='PaymentTerms.DueDate'
              defaultMessage='Due Date'
            />
          </Box>
        </Typography>
      </Grid>
      <Grid item xs={anyPaid ? 1 : 3}>
        <Typography color='primary'>
          <Box fontWeight='bold'>
            <FormattedMessage
              id='PaymentTerms.HowMuch'
              defaultMessage='How Much?'
            />
          </Box>
        </Typography>
      </Grid>
      <Grid item xs={anyPaid ? 1 : 3}>
        <Typography color='primary'>
          <Box fontWeight='bold'>
            <FormattedMessage
              id='PaymentTerms.SellPrice'
              defaultMessage='Sell Price'
            />
          </Box>
        </Typography>
      </Grid>
      {anyPaid && (
        <>
          <Grid item xs={2}>
            <Typography color='primary'>
              <Box fontWeight='bold'>
                <FormattedMessage
                  id='PaymentTerms.PaymentStatus'
                  defaultMessage='Payment Status'
                />
              </Box>
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography color='primary'>
              <Box fontWeight='bold'>
                <FormattedMessage
                  id='PaymentTerms.PaymentProcessed'
                  defaultMessage='Payment Processed'
                />
              </Box>
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography color='primary'>
              <Box fontWeight='bold'>
                <FormattedMessage
                  id='PaymentTerms.PaymentType'
                  defaultMessage='Payment Type'
                />
              </Box>
            </Typography>
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default TermsHeader;
